import http from '../../http/common'

const resource = '/source'

export default {

	get: (payload) => http.get(`${resource}/get-all${payload}`)
}
